import React, { useMemo, useContext, useEffect } from "react";
import { getEntity } from "../../Helpers/IOClient";

// import LoaderSpinner from "../../Components/Loader/LoaderSpinner/LoaderSpinner";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faEllipsisV,
//   faTicketSimple,
//   faCaretDown
// } from "@fortawesome/pro-light-svg-icons";
import {
  DashboardTitle,
  ReportsDateProvider,
  DashboardEmptyResponse
} from "./Dashboard";
import {
  spacePipelineSchema
  //   spacePipelineStatusSchema
} from "../../config/schema";
import { BarLoader } from "../../Components/GlobalLoader/GlobalLoader";
import { PieChart, BigBarChartPerformance } from "./Echarts/PerformanceChart";

import classnames from "classnames";
// import { faCaretUp } from "@fortawesome/pro-solid-svg-icons";
import moment from "moment";
// import Moment from "react-moment";
// import { msToTime } from "../../Assets/Utils";

import {
  ComboLoadChart,
  PipelineWorkloadComboLoadChart
} from "./Echarts/TicketLoadBarChart";
import { useCurrentAccount } from "../../Contexts/UserContext";
import { TaskMainViewLink } from "../../Helpers/HooksHelper";
import { AreaChart } from "./Echarts/AverageEvolutionTicketsLineChart";
import { ReverseBarChart } from "./Echarts/OpenTicketsBarChart";
import { ClosedBarChart } from "./Echarts/GlobalAverageCloseTime";
import { ComboEvolution } from "./Echarts/TicketsEvolutionLineChart";
import { FormattedMessage } from "react-intl";
import { useDashboardQuery } from "./DashboardQueryHelper";
import { useSidebar } from "../../Components/Sidebar/SidebarV2";
import { DashboardSettingsContext } from "./DashboardLayout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/pro-light-svg-icons";
import DashboardCardSettingsForm, {
  handleIntervalCalculation
} from "./DashboardCardSettingsForm";
import Button from "../../Components/Button/Button";
import CreateDashboardFilterLinksHelper from "./DashboardFilterLinksHelper";

const defaultTimeFrame = moment().subtract(180, "d").format("YYYY-MM-DD");
const lS_Group = "dashboard-layout-tasks";
export const OpenTasks = () => {
  const [openSidebar, closeSidebar] = useSidebar();
  const lS_Field = "openTasks";

  const DashboardSettings =
    JSON.parse(localStorage.getItem("ar-dashboard-settings")) || {};
  const Settings =
    (DashboardSettings &&
      DashboardSettings[lS_Group] &&
      DashboardSettings[lS_Group][lS_Field]) ||
    {};

  const handleLayoutChange = useContext(DashboardSettingsContext);

  useEffect(() => {
    return () => closeSidebar();
  }, [closeSidebar]);

  const { ...DataReports } = useContext(ReportsDateProvider);
  const { data, error, loading } = useDashboardQuery(
    `Dashboard/Services/Tasks/Counter?status=1&todate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].toDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "toDate",
              Settings.Interval
            )
        : ""
    }&fromdate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].fromDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "fromDate",
              Settings.Interval
            )
        : ""
    }${
      DataReports[0] === "Tasks"
        ? DataReports[5]
          ? `&workspace=true`
          : DataReports[4] === "Account"
          ? `&userid=${DataReports[2].Id}`
          : DataReports[4] === "Department"
          ? `&department=${DataReports[2].Id}`
          : DataReports[4] === "organization"
          ? `&company=${DataReports[2] && DataReports[2].Id}`
          : `&team=${DataReports[2].Id}`
        : ""
    }`
  );
  var account = useCurrentAccount().Id;
  const user =
    DataReports[0] === "Tasks" ? (
      DataReports[2]?.Name
    ) : (
      <FormattedMessage id={"ME"} />
    );
  if (!loading && !error) {
    const resolvedData = data.CurrentMonth;
    return (
      <div className="px-3 of-hidden">
        <div className="d-flex justify-content-between">
          <DashboardTitle
            className="mb-0 fs-20"
            text={<FormattedMessage id={"OPEN_TASKS"} />}
          />
          <div>{/* <FontAwesomeIcon icon={faEllipsisV} /> */}</div>
        </div>
        {DataReports[0] !== "Tasks" && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="mb-2">
              <span className="ar-dashboard-description">
                <FormattedMessage id={"INTERVAL"} />:
              </span>
              <span className="text-primary pl-1 fs-14">
                {Settings.Interval && Settings.Interval.title !== "ALL" ? (
                  <FormattedMessage id={Settings.Interval.title} />
                ) : (
                  <FormattedMessage id={"ALL"} />
                )}
              </span>
              <span className="ar-dashboard-description ml-1">
                | <FormattedMessage id={"SCOPE"} />:
              </span>
              <span className="text-primary pl-1 fs-14">{user}</span>
            </div>
            <Button
              className="ar-dashboard-card-settings-link"
              vType="link-primary"
              onClick={() =>
                openSidebar(
                  <DashboardCardSettingsForm
                    lS_Field={lS_Field}
                    lS_Group={lS_Group}
                    Settings={Settings}
                    closeSidebar={closeSidebar}
                    Title={"OPEN_TASKS"}
                    handleChanges={handleLayoutChange}
                    AvailableSettings={{
                      interval: true,
                      scope: true,
                      pipeline: false
                    }}
                  />
                )
              }
            >
              <FontAwesomeIcon icon={faCog} />
            </Button>
          </div>
        )}
        <TaskMainViewLink
          className="ar-dashboard-active-values mb-2"
          params={`$filter=PipelineStatus/Status eq '1'${CreateDashboardFilterLinksHelper(
            DataReports,
            account
          )}`}
        >
          {resolvedData}
        </TaskMainViewLink>

        {/* {data.Percentage !== 0 && (
          <div
            className={classnames(
              "fs-14 font-weight-bold",
              {
                "ar-dashboard-open-description": data.Percentage > 0
              },
              {
                "ar-dashboard-closed-description": data.Percentage < 0
              }
            )}
          >
            {data.Percentage > 0 ? (
              <FontAwesomeIcon icon={faCaretUp} />
            ) : (
              <FontAwesomeIcon icon={faCaretDown} />
            )}
            {Math.abs(Math.floor(data.Percentage))}% Ultimo Mês
          </div>
        )} */}
      </div>
    );
  } else {
    return (
      <BarLoader style={{ marginTop: -16 }} isLoading={loading || error} />
    );
  }
};

export const ClosedTasks = () => {
  const [openSidebar, closeSidebar] = useSidebar();
  const lS_Field = "closedTasks";

  const DashboardSettings =
    JSON.parse(localStorage.getItem("ar-dashboard-settings")) || {};
  const Settings =
    (DashboardSettings &&
      DashboardSettings[lS_Group] &&
      DashboardSettings[lS_Group][lS_Field]) ||
    {};

  const handleLayoutChange = useContext(DashboardSettingsContext);

  useEffect(() => {
    return () => closeSidebar();
  }, [closeSidebar]);
  const { ...DataReports } = useContext(ReportsDateProvider);
  var account = useCurrentAccount().Id;
  const { data, error, loading } = useDashboardQuery(
    `Dashboard/Services/Tasks/Counter?status=4&todate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].toDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "toDate",
              Settings.Interval
            )
        : ""
    }&fromdate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].fromDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "fromDate",
              Settings.Interval
            )
        : ""
    }${
      DataReports[0] === "Tasks"
        ? DataReports[5]
          ? `&workspace=true`
          : DataReports[4] === "Account"
          ? `&userid=${DataReports[2].Id}`
          : DataReports[4] === "Department"
          ? `&department=${DataReports[2].Id}`
          : DataReports[4] === "organization"
          ? `&company=${DataReports[2] && DataReports[2].Id}`
          : `&team=${DataReports[2].Id}`
        : ""
    }`
  );
  const user =
    DataReports[0] === "Tasks" ? (
      DataReports[2]?.Name
    ) : (
      <FormattedMessage id={"ME"} />
    );
  if (!loading && !error) {
    const resolvedData = data.CurrentMonth;
    return (
      <div className="px-3 of-hidden">
        <div className="d-flex justify-content-between">
          <DashboardTitle
            className="mb-0 fs-20"
            text={<FormattedMessage id={"CLOSED_TASKS"} />}
          />
          <div>{/* <FontAwesomeIcon icon={faEllipsisV} /> */}</div>
        </div>
        {DataReports[0] !== "Tasks" && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="mb-2">
              <span className="ar-dashboard-description">
                <FormattedMessage id={"INTERVAL"} />:
              </span>
              <span className="text-primary pl-1 fs-14">
                {Settings.Interval && Settings.Interval.title !== "ALL" ? (
                  <FormattedMessage id={Settings.Interval.title} />
                ) : (
                  <FormattedMessage id={"ALL"} />
                )}
              </span>
              <span className="ar-dashboard-description ml-1">
                | <FormattedMessage id={"SCOPE"} />:
              </span>
              <span className="text-primary pl-1 fs-14">{user}</span>
            </div>
            <Button
              className="ar-dashboard-card-settings-link"
              vType="link-primary"
              onClick={() =>
                openSidebar(
                  <DashboardCardSettingsForm
                    lS_Field={lS_Field}
                    lS_Group={lS_Group}
                    Settings={Settings}
                    closeSidebar={closeSidebar}
                    Title={"CLOSED_TASKS"}
                    handleChanges={handleLayoutChange}
                    AvailableSettings={{
                      interval: true,
                      scope: true,
                      pipeline: false
                    }}
                  />
                )
              }
            >
              <FontAwesomeIcon icon={faCog} />
            </Button>
          </div>
        )}
        <TaskMainViewLink
          className="ar-dashboard-closed-values mb-2"
          params={`$filter=PipelineStatus/Status eq '4'${CreateDashboardFilterLinksHelper(
            DataReports,
            account
          )}`}
        >
          {resolvedData}
        </TaskMainViewLink>
      </div>
    );
  } else {
    return (
      <BarLoader style={{ marginTop: -16 }} isLoading={loading || error} />
    );
  }
};

export const AverageOpenTimeBeforeCloseTasks = () => {
  const [openSidebar, closeSidebar] = useSidebar();
  const lS_Field = "averageOpenTimeTasks";

  const DashboardSettings =
    JSON.parse(localStorage.getItem("ar-dashboard-settings")) || {};
  const Settings =
    (DashboardSettings &&
      DashboardSettings[lS_Group] &&
      DashboardSettings[lS_Group][lS_Field]) ||
    {};

  const handleLayoutChange = useContext(DashboardSettingsContext);

  useEffect(() => {
    return () => closeSidebar();
  }, [closeSidebar]);
  const { ...DataReports } = useContext(ReportsDateProvider);
  const { data, error, loading } = useDashboardQuery(
    `Dashboard/Services/tasks/AverageClose?todate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].toDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "toDate",
              Settings.Interval
            )
        : ""
    }&fromdate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].fromDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "fromDate",
              Settings.Interval
            )
        : ""
    }${
      DataReports[0] === "Tasks"
        ? DataReports[5]
          ? `&workspace=true`
          : DataReports[4] === "Account"
          ? `&userid=${DataReports[2].Id}`
          : DataReports[4] === "Department"
          ? `&department=${DataReports[2].Id}`
          : DataReports[4] === "organization"
          ? `&company=${DataReports[2] && DataReports[2].Id}`
          : `&team=${DataReports[2].Id}`
        : ""
    }`
  );
  const user =
    DataReports[0] === "Tasks" ? (
      DataReports[2]?.Name
    ) : (
      <FormattedMessage id={"ME"} />
    );
  if (!loading && !error) {
    const resolvedData = new moment.duration(data.Average);
    let resolvedTime = Math.round(resolvedData.asDays() * 10) / 10;
    let Spec = <FormattedMessage id={"DAYS"} />;
    if (resolvedTime < 1) {
      resolvedTime = Math.round(resolvedData.asHours() * 10) / 10;
      Spec = <FormattedMessage id={"HOURS_MULTIPLE"} />;
    }
    if (resolvedTime < 1) {
      resolvedTime = Math.round(resolvedData.asMinutes() * 10) / 10;
      Spec = "Mins";
    }
    return (
      <div className="px-3 of-hidden">
        <div className="d-flex justify-content-between">
          <DashboardTitle
            className="mb-0 fs-20"
            text={<FormattedMessage id={"AVERAGE_CLOSE_TASKS"} />}
          />
          <div>{/* <FontAwesomeIcon icon={faEllipsisV} /> */}</div>
        </div>
        {DataReports[0] !== "Tasks" && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="mb-2">
              <span className="ar-dashboard-description">
                <FormattedMessage id={"INTERVAL"} />:
              </span>
              <span className="text-primary pl-1 fs-14">
                {Settings.Interval && Settings.Interval.title !== "ALL" ? (
                  <FormattedMessage id={Settings.Interval.title} />
                ) : (
                  <FormattedMessage id={"ALL"} />
                )}
              </span>
              <span className="ar-dashboard-description ml-1">
                | <FormattedMessage id={"SCOPE"} />:
              </span>
              <span className="text-primary pl-1 fs-14">{user}</span>
            </div>
            <Button
              className="ar-dashboard-card-settings-link"
              vType="link-primary"
              onClick={() =>
                openSidebar(
                  <DashboardCardSettingsForm
                    lS_Field={lS_Field}
                    lS_Group={lS_Group}
                    Settings={Settings}
                    closeSidebar={closeSidebar}
                    Title={"AVERAGE_CLOSE_TASKS"}
                    handleChanges={handleLayoutChange}
                    AvailableSettings={{
                      interval: true,
                      scope: true,
                      pipeline: false
                    }}
                  />
                )
              }
            >
              <FontAwesomeIcon icon={faCog} />
            </Button>
          </div>
        )}
        <div className="d-flex flex-column">
          <div className="ar-dashboard-values text-black">{resolvedTime}</div>
          <div className="fs-14 text-black fw-bold">{Spec}</div>
        </div>
      </div>
    );
  } else {
    return (
      <BarLoader style={{ marginTop: -16 }} isLoading={loading || error} />
    );
  }
};

export const TasksStatusTotals = () => {
  const { data, error, loading } = useDashboardQuery("query/Pipelines?Type=4", [
    spacePipelineSchema
  ]);

  if (!loading && !error) {
    return <TasksStatusTotalsResult results={data} />;
  } else {
    return <BarLoader style={{ marginTop: -16 }} isLoading={loading} />;
  }
};

const TasksStatusTotalsResult = ({ results }) => {
  const [openSidebar, closeSidebar] = useSidebar();
  const lS_Field = "StatusTasks";

  const DashboardSettings =
    JSON.parse(localStorage.getItem("ar-dashboard-settings")) || {};
  const Settings = (DashboardSettings &&
    DashboardSettings[lS_Group] &&
    DashboardSettings[lS_Group][lS_Field]) || { Pipeline: results[0] };
  const handleLayoutChange = useContext(DashboardSettingsContext);

  useEffect(() => {
    return () => closeSidebar();
  }, [closeSidebar]);

  var account = useCurrentAccount().Id;
  const { ...DataReports } = useContext(ReportsDateProvider);
  const pipeline =
    DataReports[0] === "Tasks" ? DataReports[3] : Settings.Pipeline;
  const { data, error, loading } = useDashboardQuery(
    `Dashboard/Services/Tasks/${
      pipeline ? pipeline : Settings.Pipeline
    }/StatusCounter?todate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].toDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "toDate",
              Settings.Interval
            )
        : ""
    }&fromdate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].fromDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "fromDate",
              Settings.Interval
            )
        : ""
    }${
      DataReports[0] === "Tasks"
        ? DataReports[5]
          ? `&workspace=true`
          : DataReports[4] === "Account"
          ? `&userid=${DataReports[2].Id}`
          : DataReports[4] === "Department"
          ? `&department=${DataReports[2].Id}`
          : DataReports[4] === "organization"
          ? `&company=${DataReports[2] && DataReports[2].Id}`
          : `&team=${DataReports[2].Id}`
        : ""
    }`
  );
  const user =
    DataReports[0] === "Tasks" ? (
      DataReports[2]?.Name
    ) : (
      <FormattedMessage id={"ME"} />
    );
  if (!loading && !error) {
    const resolvedData = data;
    return (
      <div className="px-3 of-hidden">
        <div className="d-flex justify-content-between">
          <DashboardTitle
            className="mb-0 fs-20"
            text={<FormattedMessage id={"TASKS_STATUS"} />}
          />
          <div>{/* <FontAwesomeIcon icon={faEllipsisV} /> */}</div>
        </div>
        {DataReports[0] !== "Tasks" && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="mb-2">
              <span className="ar-dashboard-description">
                <FormattedMessage id={"INTERVAL"} />:
              </span>
              <span className="text-primary pl-1 fs-14">
                {Settings.Interval && Settings.Interval.title !== "ALL" ? (
                  <FormattedMessage id={Settings.Interval.title} />
                ) : (
                  <FormattedMessage id={"ALL"} />
                )}
              </span>
              <span className="ar-dashboard-description ml-1">
                | <FormattedMessage id={"SCOPE"} />:
              </span>
              <span className="text-primary pl-1 fs-14">{user}</span>
              <span className="ar-dashboard-description ml-1">
                | <FormattedMessage id={"PIPELINE"} />:
              </span>
              <span className="text-primary pl-1 fs-14">
                {
                  getEntity(
                    spacePipelineSchema,
                    pipeline ? pipeline : Settings.Pipeline
                  )?.Name
                }
              </span>
            </div>
            <Button
              className="ar-dashboard-card-settings-link"
              vType="link-primary"
              onClick={() =>
                openSidebar(
                  <DashboardCardSettingsForm
                    lS_Field={lS_Field}
                    lS_Group={lS_Group}
                    Settings={Settings}
                    closeSidebar={closeSidebar}
                    pipelineType={4}
                    Title={"TASKS_STATUS"}
                    handleChanges={handleLayoutChange}
                    AvailableSettings={{
                      interval: true,
                      scope: true,
                      pipeline: true
                    }}
                  />
                )
              }
            >
              <FontAwesomeIcon icon={faCog} />
            </Button>
          </div>
        )}
        <div className="d-flex justify-content-between px-2">
          {resolvedData.map((e, i) => {
            return (
              <div key={i} className="d-flex flex-column">
                <TaskMainViewLink
                  className={classnames({
                    "ar-dashboard-active-values": e.PipelineStatus.Status === 1,
                    "ar-dashboard-closed-values": e.PipelineStatus.Status === 4,
                    "ar-dashboard-canceled-values":
                      e.PipelineStatus.Status === 3,
                    "ar-dashboard-draft-values": e.PipelineStatus.Status === 5
                  })}
                  params={`$filter=Task/PipelineStatusId eq '${
                    e.PipelineStatus.Id
                  }'${CreateDashboardFilterLinksHelper(
                    DataReports,
                    account
                  )}&pipeline=${pipeline}`}
                >
                  {e.Count}
                </TaskMainViewLink>

                <div
                  className={classnames({
                    "ar-dashboard-active-description":
                      e.PipelineStatus.Status === 1,
                    "ar-dashboard-closed-description":
                      e.PipelineStatus.Status === 4,
                    "ar-dashboard-canceled-description":
                      e.PipelineStatus.Status === 3,
                    "ar-dashboard-draft-description":
                      e.PipelineStatus.Status === 5
                  })}
                >
                  {e.PipelineStatus?.Name}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  } else {
    return (
      <BarLoader style={{ marginTop: -16 }} isLoading={loading || error} />
    );
  }
};

export const AverageEvolutionClosedTasks = () => {
  const [openSidebar, closeSidebar] = useSidebar();
  const lS_Field = "evolutionClosedTasks";

  const DashboardSettings =
    JSON.parse(localStorage.getItem("ar-dashboard-settings")) || {};
  const Settings =
    (DashboardSettings &&
      DashboardSettings[lS_Group] &&
      DashboardSettings[lS_Group][lS_Field]) ||
    {};

  const handleLayoutChange = useContext(DashboardSettingsContext);

  useEffect(() => {
    return () => closeSidebar();
  }, [closeSidebar]);
  const { ...DataReports } = useContext(ReportsDateProvider);
  const { data, error, loading } = useDashboardQuery(
    `Dashboard/Services/tasks/AverageCloseTime?todate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].toDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "toDate",
              Settings.Interval
            )
        : ""
    }&fromdate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].fromDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? defaultTimeFrame
          : handleIntervalCalculation(
              Settings.Interval.title,
              "fromDate",
              Settings.Interval
            )
        : defaultTimeFrame
    }${
      DataReports[0] === "Tasks"
        ? DataReports[5]
          ? `&workspace=true`
          : DataReports[4] === "Account"
          ? `&userid=${DataReports[2].Id}`
          : DataReports[4] === "Department"
          ? `&department=${DataReports[2].Id}`
          : DataReports[4] === "organization"
          ? `&company=${DataReports[2] && DataReports[2].Id}`
          : `&team=${DataReports[2].Id}`
        : ""
    }`
  );
  const user =
    DataReports[0] === "Tasks" ? (
      DataReports[2]?.Name
    ) : (
      <FormattedMessage id={"ME"} />
    );
  if (!loading && !error) {
    const { Results, HasData } = data;
    //console.log(resolvedData);
    return (
      <div className="px-3 of-hidden h-100 d-flex flex-column">
        <div className="d-flex justify-content-between">
          <DashboardTitle
            className="mb-0 fs-20"
            text={<FormattedMessage id={"PROGRESS_CLOSED_TASKS"} />}
          />
          <div>{/* <FontAwesomeIcon icon={faEllipsisV} /> */}</div>
        </div>
        {DataReports[0] !== "Tasks" && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="mb-2">
              <span className="ar-dashboard-description">
                <FormattedMessage id={"INTERVAL"} />:
              </span>
              <span className="text-primary pl-1 fs-14">
                {Settings.Interval && Settings.Interval.title !== "ALL" ? (
                  <FormattedMessage id={Settings.Interval.title} />
                ) : (
                  <FormattedMessage id={"ALL"} />
                )}
              </span>
              <span className="ar-dashboard-description ml-1">
                | <FormattedMessage id={"SCOPE"} />:
              </span>
              <span className="text-primary pl-1 fs-14">{user}</span>
            </div>
            <Button
              className="ar-dashboard-card-settings-link"
              vType="link-primary"
              onClick={() =>
                openSidebar(
                  <DashboardCardSettingsForm
                    lS_Field={lS_Field}
                    lS_Group={lS_Group}
                    Settings={Settings}
                    closeSidebar={closeSidebar}
                    Title={"PROGRESS_CLOSED_TASKS"}
                    handleChanges={handleLayoutChange}
                    AvailableSettings={{
                      interval: true,
                      scope: true,
                      pipeline: false
                    }}
                  />
                )
              }
            >
              <FontAwesomeIcon icon={faCog} />
            </Button>
          </div>
        )}
        {HasData ? (
          <div className="h-100">
            <AreaChart Data={Results} />
          </div>
        ) : (
          <DashboardEmptyResponse className="header h-100" type="tasks">
            {<FormattedMessage id={"EMPTY_TASKS"} />}
          </DashboardEmptyResponse>
        )}
      </div>
    );
  } else {
    return (
      <BarLoader style={{ marginTop: -16 }} isLoading={loading || error} />
    );
  }
};

export const PerformanceTasks = () => {
  const [openSidebar, closeSidebar] = useSidebar();
  const lS_Field = "performanceTasks";

  const DashboardSettings =
    JSON.parse(localStorage.getItem("ar-dashboard-settings")) || {};
  const Settings =
    (DashboardSettings &&
      DashboardSettings[lS_Group] &&
      DashboardSettings[lS_Group][lS_Field]) ||
    {};

  const handleLayoutChange = useContext(DashboardSettingsContext);

  useEffect(() => {
    return () => closeSidebar();
  }, [closeSidebar]);
  const { ...DataReports } = useContext(ReportsDateProvider);
  const { data, error, loading } = useDashboardQuery(
    `Dashboard/Services/Tasks/Performance?todate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].toDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "toDate",
              Settings.Interval
            )
        : ""
    }&fromdate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].fromDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "fromDate",
              Settings.Interval
            )
        : ""
    }${
      DataReports[0] === "Tasks"
        ? DataReports[5]
          ? `&workspace=true`
          : DataReports[4] === "Account"
          ? `&userid=${DataReports[2].Id}`
          : DataReports[4] === "Department"
          ? `&department=${DataReports[2].Id}`
          : DataReports[4] === "organization"
          ? `&company=${DataReports[2] && DataReports[2].Id}`
          : `&team=${DataReports[2].Id}`
        : ""
    }`
  );
  const user =
    DataReports[0] === "Tasks" ? (
      DataReports[2]?.Name
    ) : (
      <FormattedMessage id={"ME"} />
    );
  const resolvedData = useMemo(() => {
    if (!data) return null;

    const resolvedData = {};
    const { Results } = data;
    if (Array.isArray(Results)) {
      for (const e of Results) {
        if (e.Status === 1) {
          resolvedData.Open = [e.Count, Math.round(e.Percentage)];
        } else if (e.Status === 3) {
          resolvedData.Canceled = [e.Count, Math.round(e.Percentage)];
        } else if (e.Status === 4) {
          resolvedData.Closed = [e.Count, Math.round(e.Percentage)];
        }
      }
    }
    return resolvedData;
  }, [data]);

  if (!loading && !error) {
    const { HasData } = data;
    return (
      <div className="px-3 of-hidden h-100 d-flex flex-column">
        <div className="d-flex justify-content-between">
          <DashboardTitle
            className="mb-0 fs-20"
            text={<FormattedMessage id={"TASKS_PERFORMANCE"} />}
          />
          <div>{/* <FontAwesomeIcon icon={faEllipsisV} /> */}</div>
        </div>
        {DataReports[0] !== "Tasks" && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="mb-2">
              <span className="ar-dashboard-description">
                <FormattedMessage id={"INTERVAL"} />:
              </span>
              <span className="text-primary pl-1 fs-14">
                {Settings.Interval && Settings.Interval.title !== "ALL" ? (
                  <FormattedMessage id={Settings.Interval.title} />
                ) : (
                  <FormattedMessage id={"ALL"} />
                )}
              </span>
              <span className="ar-dashboard-description ml-1">
                | <FormattedMessage id={"SCOPE"} />:
              </span>
              <span className="text-primary pl-1 fs-14">{user}</span>
            </div>
            <Button
              className="ar-dashboard-card-settings-link"
              vType="link-primary"
              onClick={() =>
                openSidebar(
                  <DashboardCardSettingsForm
                    lS_Field={lS_Field}
                    lS_Group={lS_Group}
                    Settings={Settings}
                    closeSidebar={closeSidebar}
                    Title={"TASKS_PERFORMANCE"}
                    handleChanges={handleLayoutChange}
                    AvailableSettings={{
                      interval: true,
                      scope: true,
                      pipeline: false
                    }}
                  />
                )
              }
            >
              <FontAwesomeIcon icon={faCog} />
            </Button>
          </div>
        )}
        {HasData ? (
          <div className="h-100">
            <PieChart Data={resolvedData} />
          </div>
        ) : (
          <DashboardEmptyResponse className="header h-100" type="tasks">
            {<FormattedMessage id={"EMPTY_TASKS"} />}
          </DashboardEmptyResponse>
        )}
      </div>
    );
  } else {
    return (
      <BarLoader style={{ marginTop: -16 }} isLoading={loading || error} />
    );
  }
};

export const EvolutionTasks = () => {
  const [openSidebar, closeSidebar] = useSidebar();
  const lS_Field = "evolutionTasks";

  const DashboardSettings =
    JSON.parse(localStorage.getItem("ar-dashboard-settings")) || {};
  const Settings =
    (DashboardSettings &&
      DashboardSettings[lS_Group] &&
      DashboardSettings[lS_Group][lS_Field]) ||
    {};

  const handleLayoutChange = useContext(DashboardSettingsContext);

  useEffect(() => {
    return () => closeSidebar();
  }, [closeSidebar]);

  const { ...DataReports } = useContext(ReportsDateProvider);
  const { data, error, loading } = useDashboardQuery(
    `Dashboard/Services/Tasks/Evolution?todate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].toDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "toDate",
              Settings.Interval
            )
        : ""
    }&fromdate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].fromDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? defaultTimeFrame
          : handleIntervalCalculation(
              Settings.Interval.title,
              "fromDate",
              Settings.Interval
            )
        : defaultTimeFrame
    }${
      DataReports[0] === "Tasks"
        ? DataReports[5]
          ? `&workspace=true`
          : DataReports[4] === "Account"
          ? `&userid=${DataReports[2].Id}`
          : DataReports[4] === "Department"
          ? `&department=${DataReports[2].Id}`
          : DataReports[4] === "organization"
          ? `&company=${DataReports[2] && DataReports[2].Id}`
          : `&team=${DataReports[2].Id}`
        : ""
    }`
  );
  const user =
    DataReports[0] === "Tasks" ? (
      DataReports[2]?.Name
    ) : (
      <FormattedMessage id={"ME"} />
    );
  if (!loading && !error) {
    const { Results, HasData } = data;
    return (
      <div className="px-3 of-hidden h-100 d-flex flex-column">
        <div className="d-flex justify-content-between">
          <DashboardTitle
            className="mb-0 fs-20"
            text={<FormattedMessage id={"TASKS_PROGRESS"} />}
          />
          <div>{/* <FontAwesomeIcon icon={faEllipsisV} /> */}</div>
        </div>
        {DataReports[0] !== "Tasks" && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="mb-2">
              <span className="ar-dashboard-description">
                <FormattedMessage id={"INTERVAL"} />:
              </span>
              <span className="text-primary pl-1 fs-14">
                {Settings.Interval && Settings.Interval.title !== "ALL" ? (
                  <FormattedMessage id={Settings.Interval.title} />
                ) : (
                  <FormattedMessage id={"ALL"} />
                )}
              </span>
              <span className="ar-dashboard-description ml-1">
                | <FormattedMessage id={"SCOPE"} />:
              </span>
              <span className="text-primary pl-1 fs-14">{user}</span>
            </div>
            <Button
              className="ar-dashboard-card-settings-link"
              vType="link-primary"
              onClick={() =>
                openSidebar(
                  <DashboardCardSettingsForm
                    lS_Field={lS_Field}
                    lS_Group={lS_Group}
                    Settings={Settings}
                    closeSidebar={closeSidebar}
                    Title={"TASKS_PROGRESS"}
                    handleChanges={handleLayoutChange}
                    AvailableSettings={{
                      interval: true,
                      scope: true,
                      pipeline: false
                    }}
                  />
                )
              }
            >
              <FontAwesomeIcon icon={faCog} />
            </Button>
          </div>
        )}
        {HasData ? (
          <div className="h-100">
            <ComboEvolution Data={Results} />
          </div>
        ) : (
          <DashboardEmptyResponse className="header h-100" type="tasks">
            {<FormattedMessage id={"EMPTY_TASKS"} />}
          </DashboardEmptyResponse>
        )}
      </div>
    );
  } else {
    return (
      <BarLoader style={{ marginTop: -16 }} isLoading={loading || error} />
    );
  }
};

export const DepartmentWorkloadTasks = () => {
  const [openSidebar, closeSidebar] = useSidebar();
  const lS_Field = "departmentWorkloadTasks";

  const DashboardSettings =
    JSON.parse(localStorage.getItem("ar-dashboard-settings")) || {};
  const Settings =
    (DashboardSettings &&
      DashboardSettings[lS_Group] &&
      DashboardSettings[lS_Group][lS_Field]) ||
    {};

  const handleLayoutChange = useContext(DashboardSettingsContext);

  useEffect(() => {
    return () => closeSidebar();
  }, [closeSidebar]);

  const { ...DataReports } = useContext(ReportsDateProvider);
  const { data, error, loading } = useDashboardQuery(
    `Dashboard/Services/tasks/Rank?&top=7&todate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].toDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "toDate",
              Settings.Interval
            )
        : ""
    }&fromdate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].fromDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? defaultTimeFrame
          : handleIntervalCalculation(
              Settings.Interval.title,
              "fromDate",
              Settings.Interval
            )
        : defaultTimeFrame
    }${
      DataReports[0] === "Tasks"
        ? DataReports[5]
          ? `&workspace=true`
          : DataReports[4] === "Account"
          ? `&userid=${DataReports[2].Id}`
          : DataReports[4] === "Department"
          ? `&department=${DataReports[2].Id}`
          : DataReports[4] === "organization"
          ? `&company=${DataReports[2] && DataReports[2].Id}`
          : `&team=${DataReports[2].Id}`
        : ""
    }`
  );
  const user =
    DataReports[0] === "Tasks" ? (
      DataReports[2]?.Name
    ) : (
      <FormattedMessage id={"MY_DEPARTMENTS"} />
    );
  if (!loading && !error) {
    data.splice(20, data.length - 21);
    const Results = data;
    let HasData = false;
    for (const e of Results) {
      const { Data } = e;
      for (const key in Data) {
        if (Object.hasOwnProperty.call(Data, key)) {
          const element = Data[key];
          if (parseInt(element) > 0) {
            HasData = true;
            break;
          }
        }
      }
      if (HasData) {
        break;
      }
    }

    return (
      <div className="px-3 of-hidden h-100 d-flex flex-column">
        <div className="d-flex justify-content-between">
          <DashboardTitle
            className="mb-0 fs-20"
            text={<FormattedMessage id={"DEPARTMENT_LOAD"} />}
          />
          <div>{/* <FontAwesomeIcon icon={faEllipsisV} /> */}</div>
        </div>
        {DataReports[0] !== "Tasks" && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="mb-2">
              <span className="ar-dashboard-description">
                <FormattedMessage id={"INTERVAL"} />:
              </span>
              <span className="text-primary pl-1 fs-14">
                {Settings.Interval && Settings.Interval.title !== "ALL" ? (
                  <FormattedMessage id={Settings.Interval.title} />
                ) : (
                  <FormattedMessage id={"ALL"} />
                )}
              </span>
              <span className="ar-dashboard-description ml-1">
                | <FormattedMessage id={"SCOPE"} />:
              </span>
              <span className="text-primary pl-1 fs-14">{user}</span>
            </div>
            <Button
              className="ar-dashboard-card-settings-link"
              vType="link-primary"
              onClick={() =>
                openSidebar(
                  <DashboardCardSettingsForm
                    lS_Field={lS_Field}
                    lS_Group={lS_Group}
                    Settings={Settings}
                    closeSidebar={closeSidebar}
                    Title={"DEPARTMENT_LOAD"}
                    handleChanges={handleLayoutChange}
                    AvailableSettings={{
                      interval: true,
                      scope: true,
                      pipeline: false
                    }}
                  />
                )
              }
            >
              <FontAwesomeIcon icon={faCog} />
            </Button>
          </div>
        )}
        {HasData ? (
          <div className="h-100">
            <ComboLoadChart Data={Results} />
          </div>
        ) : (
          <DashboardEmptyResponse className="header h-100" type="tasks">
            {<FormattedMessage id={"EMPTY_TASKS"} />}
          </DashboardEmptyResponse>
        )}
        {/* {Results.length === 0 ? (
          <DashboardEmptyResponse className="header h-100" type="tasks">
            {<FormattedMessage id={"EMPTY_TASKS"} />}
          </DashboardEmptyResponse>
        ) : (
          <div className="h-100">
            <ComboLoadChart Data={Results} />
          </div>
        )} */}
      </div>
    );
  } else {
    if (!loading && error.status === 403) {
      return (
        <div className="px-3 of-hidden h-100 d-flex flex-column">
          <div className="d-flex justify-content-between">
            <DashboardTitle
              className="mb-0 fs-20"
              text={<FormattedMessage id={"DEPARTMENT_LOAD"} />}
            />
            <div>{/* <FontAwesomeIcon icon={faEllipsisV} /> */}</div>
          </div>
          {DataReports[0] !== "Tasks" && (
            <div className="mb-2">
              <span className="ar-dashboard-description">
                <FormattedMessage id={"INTERVAL"} />:
              </span>
              <span className="text-primary pl-1 fs-14">
                {" "}
                {DataReports[0] === "Tasks" ? (
                  <>
                    <FormattedMessage id={"FROM"} />{" "}
                    {DataReports[1].fromDateString}{" "}
                    <FormattedMessage id={"TO"} /> {DataReports[1].toDateString}
                  </>
                ) : (
                  <FormattedMessage id={"ALL"} />
                )}
              </span>
              <span className="ar-dashboard-description ml-1">
                | <FormattedMessage id={"DEPARTMENT"} />
              </span>
              <span className="text-primary pl-1 fs-14">{user}</span>
            </div>
          )}

          <DashboardEmptyResponse type="tasks">
            {DataReports ? (
              DataReports[4] === "Account" ? (
                <FormattedMessage id={"EMPLOYEE_NO_DEPARTMNET"} />
              ) : (
                <FormattedMessage id={"EMPLOYE_NO_FILTER"} />
              )
            ) : (
              <FormattedMessage id={"EMPLOYEE"} />
            )}
          </DashboardEmptyResponse>
        </div>
      );
    }

    return (
      <BarLoader style={{ marginTop: -16 }} isLoading={loading || error} />
    );
  }
};

export const TeamWorkloadTasks = () => {
  const [openSidebar, closeSidebar] = useSidebar();
  const lS_Field = "teamWorkloadTasks";

  const DashboardSettings =
    JSON.parse(localStorage.getItem("ar-dashboard-settings")) || {};
  const Settings =
    (DashboardSettings &&
      DashboardSettings[lS_Group] &&
      DashboardSettings[lS_Group][lS_Field]) ||
    {};

  const handleLayoutChange = useContext(DashboardSettingsContext);

  useEffect(() => {
    return () => closeSidebar();
  }, [closeSidebar]);

  const { ...DataReports } = useContext(ReportsDateProvider);
  const { data, error, loading } = useDashboardQuery(
    `Dashboard/Services/tasks/TeamRank?top=7&todate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].toDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "toDate",
              Settings.Interval
            )
        : ""
    }&fromdate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].fromDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? defaultTimeFrame
          : handleIntervalCalculation(
              Settings.Interval.title,
              "fromDate",
              Settings.Interval
            )
        : defaultTimeFrame
    }${
      DataReports[0] === "Tasks"
        ? DataReports[5]
          ? `&workspace=true`
          : DataReports[4] === "Account"
          ? `&userid=${DataReports[2].Id}`
          : DataReports[4] === "Department"
          ? `&department=${DataReports[2].Id}`
          : DataReports[4] === "organization"
          ? `&company=${DataReports[2] && DataReports[2].Id}`
          : `&team=${DataReports[2].Id}`
        : ""
    }`
  );
  const user =
    DataReports[0] === "Tasks" ? (
      DataReports[2]?.Name
    ) : (
      <FormattedMessage id={"ME"} />
    );
  if (!loading && !error) {
    data.splice(20, data.length - 21);
    const Results = data;

    let HasData = false;
    for (const e of Results) {
      const { Data } = e;
      for (const key in Data) {
        if (Object.hasOwnProperty.call(Data, key)) {
          const element = Data[key];
          if (parseInt(element) > 0) {
            HasData = true;
            break;
          }
        }
      }
      if (HasData) {
        break;
      }
    }

    return (
      <div className="px-3 of-hidden h-100 d-flex flex-column">
        <div className="d-flex justify-content-between">
          <DashboardTitle
            className="mb-0 fs-20"
            text={<FormattedMessage id={"TEAM_LOAD"} />}
          />
          <div>{/* <FontAwesomeIcon icon={faEllipsisV} /> */}</div>
        </div>
        {DataReports[0] !== "Tasks" && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="mb-2">
              <span className="ar-dashboard-description">
                <FormattedMessage id={"INTERVAL"} />:
              </span>
              <span className="text-primary pl-1 fs-14">
                {Settings.Interval && Settings.Interval.title !== "ALL" ? (
                  <FormattedMessage id={Settings.Interval.title} />
                ) : (
                  <FormattedMessage id={"ALL"} />
                )}
              </span>
              <span className="ar-dashboard-description ml-1">
                | <FormattedMessage id={"SCOPE"} />:
              </span>
              <span className="text-primary pl-1 fs-14">{user}</span>
            </div>
            <Button
              className="ar-dashboard-card-settings-link"
              vType="link-primary"
              onClick={() =>
                openSidebar(
                  <DashboardCardSettingsForm
                    lS_Field={lS_Field}
                    lS_Group={lS_Group}
                    Settings={Settings}
                    closeSidebar={closeSidebar}
                    Title={"TEAM_LOAD"}
                    handleChanges={handleLayoutChange}
                    AvailableSettings={{
                      interval: true,
                      scope: true,
                      pipeline: false
                    }}
                  />
                )
              }
            >
              <FontAwesomeIcon icon={faCog} />
            </Button>
          </div>
        )}
        {HasData ? (
          <div className="h-100">
            <ComboLoadChart Data={Results} />
          </div>
        ) : (
          <DashboardEmptyResponse className="header h-100" type="tasks">
            <FormattedMessage id={"EMPTY_TASKS"} />
          </DashboardEmptyResponse>
        )}
        {/* {Results.length === 0 ? (
          <DashboardEmptyResponse className="header h-100" type="tasks">
            <FormattedMessage id={"EMPTY_TASKS"} />
          </DashboardEmptyResponse>
        ) : (
          <div className="h-100">
            <ComboLoadChart Data={Results} />
          </div>
        )} */}
      </div>
    );
  } else {
    if (!loading && error.status === 403) {
      return (
        <div className="px-3 of-hidden h-100 d-flex flex-column">
          <div className="d-flex justify-content-between">
            <DashboardTitle
              className="mb-0 fs-20"
              text={<FormattedMessage id={"TEAM_LOAD"} />}
            />
            <div>{/* <FontAwesomeIcon icon={faEllipsisV} /> */}</div>
          </div>
          {DataReports[0] !== "Tasks" && (
            <div className="d-flex justify-content-between align-items-center">
              <div className="mb-2">
                <span className="ar-dashboard-description">
                  <FormattedMessage id={"INTERVAL"} />:
                </span>
                <span className="text-primary pl-1 fs-14">
                  {Settings.Interval && Settings.Interval.title !== "ALL" ? (
                    <FormattedMessage id={Settings.Interval.title} />
                  ) : (
                    <FormattedMessage id={"ALL"} />
                  )}
                </span>
                <span className="ar-dashboard-description ml-1">
                  | <FormattedMessage id={"SCOPE"} />:
                </span>
                <span className="text-primary pl-1 fs-14">{user}</span>
              </div>
              <Button
                className="ar-dashboard-card-settings-link"
                vType="link-primary"
                onClick={() =>
                  openSidebar(
                    <DashboardCardSettingsForm
                      lS_Field={lS_Field}
                      lS_Group={lS_Group}
                      Settings={Settings}
                      closeSidebar={closeSidebar}
                      Title={"TEAM_LOAD"}
                      handleChanges={handleLayoutChange}
                      AvailableSettings={{
                        interval: true,
                        scope: true,
                        pipeline: false
                      }}
                    />
                  )
                }
              >
                <FontAwesomeIcon icon={faCog} />
              </Button>
            </div>
          )}

          <DashboardEmptyResponse type="tasks">
            {DataReports ? (
              DataReports[4] === "Account" ? (
                <FormattedMessage id={"EMPLOYEE_NO_DEPARTMNET"} />
              ) : (
                <FormattedMessage id={"EMPLOYE_NO_FILTER"} />
              )
            ) : (
              <FormattedMessage id={"EMPLOYEE"} />
            )}
          </DashboardEmptyResponse>
        </div>
      );
    }

    return (
      <BarLoader style={{ marginTop: -16 }} isLoading={loading || error} />
    );
  }
};

export const ResolutionTimeOpenedTasks = () => {
  const [openSidebar, closeSidebar] = useSidebar();
  const lS_Field = "resolutionTimeOpenTasks";

  const DashboardSettings =
    JSON.parse(localStorage.getItem("ar-dashboard-settings")) || {};
  const Settings =
    (DashboardSettings &&
      DashboardSettings[lS_Group] &&
      DashboardSettings[lS_Group][lS_Field]) ||
    {};

  const handleLayoutChange = useContext(DashboardSettingsContext);

  useEffect(() => {
    return () => closeSidebar();
  }, [closeSidebar]);

  const { ...DataReports } = useContext(ReportsDateProvider);
  const { data, error, loading } = useDashboardQuery(
    `Dashboard/Services/tasks/RankDayTime?todate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].toDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "toDate",
              Settings.Interval
            )
        : ""
    }&fromdate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].fromDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? defaultTimeFrame
          : handleIntervalCalculation(
              Settings.Interval.title,
              "fromDate",
              Settings.Interval
            )
        : defaultTimeFrame
    }${
      DataReports[0] === "Tasks"
        ? DataReports[5]
          ? `&workspace=true`
          : DataReports[4] === "Account"
          ? `&userid=${DataReports[2].Id}`
          : DataReports[4] === "Department"
          ? `&department=${DataReports[2].Id}`
          : DataReports[4] === "organization"
          ? `&company=${DataReports[2] && DataReports[2].Id}`
          : `&team=${DataReports[2].Id}`
        : ""
    }`
  );
  const user =
    DataReports[0] === "Tasks" ? (
      DataReports[2]?.Name
    ) : (
      <FormattedMessage id={"ME"} />
    );
  if (!loading && !error) {
    const { Results, HasData } = data;

    return (
      <div className="px-3 of-hidden h-100 d-flex flex-column">
        <div className="d-flex justify-content-between">
          <DashboardTitle
            className="mb-0 fs-20"
            text={<FormattedMessage id={"OPEN_TASKS_PROGRESS"} />}
          />
          <div>{/* <FontAwesomeIcon icon={faEllipsisV} /> */}</div>
        </div>
        {DataReports[0] !== "Tasks" && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="mb-2">
              <span className="ar-dashboard-description">
                <FormattedMessage id={"INTERVAL"} />:
              </span>
              <span className="text-primary pl-1 fs-14">
                {Settings.Interval && Settings.Interval.title !== "ALL" ? (
                  <FormattedMessage id={Settings.Interval.title} />
                ) : (
                  <FormattedMessage id={"ALL"} />
                )}
              </span>
              <span className="ar-dashboard-description ml-1">
                | <FormattedMessage id={"SCOPE"} />:
              </span>
              <span className="text-primary pl-1 fs-14">{user}</span>
            </div>
            <Button
              className="ar-dashboard-card-settings-link"
              vType="link-primary"
              onClick={() =>
                openSidebar(
                  <DashboardCardSettingsForm
                    lS_Field={lS_Field}
                    lS_Group={lS_Group}
                    Settings={Settings}
                    closeSidebar={closeSidebar}
                    Title={"OPEN_TASKS_PROGRESS"}
                    handleChanges={handleLayoutChange}
                    AvailableSettings={{
                      interval: true,
                      scope: true,
                      pipeline: false
                    }}
                  />
                )
              }
            >
              <FontAwesomeIcon icon={faCog} />
            </Button>
          </div>
        )}
        {HasData ? (
          <div className="h-100">
            <ReverseBarChart Data={Results} />
          </div>
        ) : (
          <DashboardEmptyResponse className="header h-100" type="tasks">
            <FormattedMessage id={"EMPTY_TASKS"} />
          </DashboardEmptyResponse>
        )}
      </div>
    );
  } else {
    return (
      <BarLoader style={{ marginTop: -16 }} isLoading={loading || error} />
    );
  }
};

export const DepartmentAverageCloseTimeTasks = () => {
  const [openSidebar, closeSidebar] = useSidebar();
  const lS_Field = "averageTimeClosingTasks";

  const DashboardSettings =
    JSON.parse(localStorage.getItem("ar-dashboard-settings")) || {};
  const Settings =
    (DashboardSettings &&
      DashboardSettings[lS_Group] &&
      DashboardSettings[lS_Group][lS_Field]) ||
    {};

  const handleLayoutChange = useContext(DashboardSettingsContext);

  useEffect(() => {
    return () => closeSidebar();
  }, [closeSidebar]);
  const { ...DataReports } = useContext(ReportsDateProvider);
  const { data, error, loading } = useDashboardQuery(
    `Dashboard/Services/tasks/UserCloseRank?top=7&todate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].toDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "toDate",
              Settings.Interval
            )
        : ""
    }&fromdate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].fromDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? defaultTimeFrame
          : handleIntervalCalculation(
              Settings.Interval.title,
              "fromDate",
              Settings.Interval
            )
        : defaultTimeFrame
    }${
      DataReports[0] === "Tasks"
        ? DataReports[5]
          ? `&workspace=true`
          : DataReports[4] === "Account"
          ? `&userid=${DataReports[2].Id}`
          : DataReports[4] === "Department"
          ? `&department=${DataReports[2].Id}`
          : DataReports[4] === "organization"
          ? `&company=${DataReports[2] && DataReports[2].Id}`
          : `&team=${DataReports[2].Id}`
        : ""
    }`
  );
  const user =
    DataReports[0] === "Tasks" ? (
      DataReports[2]?.Name
    ) : (
      <FormattedMessage id={"MY_DEPARTMENTS"} />
    );
  if (!loading && !error) {
    const { Results, HasData } = data;
    return (
      <div className="px-3 of-hidden h-100 d-flex flex-column">
        <div className="d-flex justify-content-between">
          <DashboardTitle
            className="mb-0 fs-20"
            text={<FormattedMessage id={"DEPARTMENT_TASKS_AVERAGE"} />}
          />
          <div>{/* <FontAwesomeIcon icon={faEllipsisV} /> */}</div>
        </div>
        {DataReports[0] !== "Tasks" && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="mb-2">
              <span className="ar-dashboard-description">
                <FormattedMessage id={"INTERVAL"} />:
              </span>
              <span className="text-primary pl-1 fs-14">
                {Settings.Interval && Settings.Interval.title !== "ALL" ? (
                  <FormattedMessage id={Settings.Interval.title} />
                ) : (
                  <FormattedMessage id={"ALL"} />
                )}
              </span>
              <span className="ar-dashboard-description ml-1">
                | <FormattedMessage id={"SCOPE"} />:
              </span>
              <span className="text-primary pl-1 fs-14">{user}</span>
            </div>
            <Button
              className="ar-dashboard-card-settings-link"
              vType="link-primary"
              onClick={() =>
                openSidebar(
                  <DashboardCardSettingsForm
                    lS_Field={lS_Field}
                    lS_Group={lS_Group}
                    Settings={Settings}
                    closeSidebar={closeSidebar}
                    Title={"DEPARTMENT_TASKS_AVERAGE"}
                    handleChanges={handleLayoutChange}
                    AvailableSettings={{
                      interval: true,
                      scope: true,
                      pipeline: false
                    }}
                  />
                )
              }
            >
              <FontAwesomeIcon icon={faCog} />
            </Button>
          </div>
        )}
        {HasData ? (
          <div className="h-100">
            <ClosedBarChart Data={Results} />
          </div>
        ) : (
          <DashboardEmptyResponse className="header h-100" type="tasks">
            <FormattedMessage id={"EMPTY_TASKS"} />
          </DashboardEmptyResponse>
        )}
        {/* {Results.length === 0 ? (
          <DashboardEmptyResponse className="header h-100" type="tasks">
            <FormattedMessage id={"EMPTY_TASKS"} />
          </DashboardEmptyResponse>
        ) : (
          <div className="h-100">
            <ClosedBarChart Data={Results} />
          </div>
        )} */}
      </div>
    );
  } else {
    if (!loading && error.status === 403) {
      return (
        <div className="px-3 of-hidden h-100 d-flex flex-column">
          <div className="d-flex justify-content-between">
            <DashboardTitle
              className="mb-0 fs-20"
              text={<FormattedMessage id={"DEPARTMENT_TASKS_AVERAGE"} />}
            />
            <div>{/* <FontAwesomeIcon icon={faEllipsisV} /> */}</div>
          </div>
          {DataReports[0] !== "Tasks" && (
            <div className="d-flex justify-content-between align-items-center">
              <div className="mb-2">
                <span className="ar-dashboard-description">
                  <FormattedMessage id={"INTERVAL"} />:
                </span>
                <span className="text-primary pl-1 fs-14">
                  {Settings.Interval && Settings.Interval.title !== "ALL" ? (
                    <FormattedMessage id={Settings.Interval.title} />
                  ) : (
                    <FormattedMessage id={"ALL"} />
                  )}
                </span>
                <span className="ar-dashboard-description ml-1">
                  | <FormattedMessage id={"SCOPE"} />:
                </span>
                <span className="text-primary pl-1 fs-14">{user}</span>
              </div>
              <Button
                className="ar-dashboard-card-settings-link"
                vType="link-primary"
                onClick={() =>
                  openSidebar(
                    <DashboardCardSettingsForm
                      lS_Field={lS_Field}
                      lS_Group={lS_Group}
                      Settings={Settings}
                      closeSidebar={closeSidebar}
                      Title={"DEPARTMENT_TASKS_AVERAGE"}
                      handleChanges={handleLayoutChange}
                      AvailableSettings={{
                        interval: true,
                        scope: true,
                        pipeline: false
                      }}
                    />
                  )
                }
              >
                <FontAwesomeIcon icon={faCog} />
              </Button>
            </div>
          )}

          <DashboardEmptyResponse type="tasks">
            {DataReports ? (
              DataReports[4] === "Account" ? (
                <FormattedMessage id={"EMPLOYEE_NO_DEPARTMNET"} />
              ) : (
                <FormattedMessage id={"EMPLOYE_NO_FILTER"} />
              )
            ) : (
              <FormattedMessage id={"EMPLOYEE"} />
            )}
          </DashboardEmptyResponse>
        </div>
      );
    }

    return (
      <BarLoader style={{ marginTop: -16 }} isLoading={loading || error} />
    );
  }
};

export const TeamAverageCloseTimeTasks = () => {
  const [openSidebar, closeSidebar] = useSidebar();
  const lS_Field = "teamAverageTimeClosingTasks";

  const DashboardSettings =
    JSON.parse(localStorage.getItem("ar-dashboard-settings")) || {};
  const Settings =
    (DashboardSettings &&
      DashboardSettings[lS_Group] &&
      DashboardSettings[lS_Group][lS_Field]) ||
    {};

  const handleLayoutChange = useContext(DashboardSettingsContext);

  useEffect(() => {
    return () => closeSidebar();
  }, [closeSidebar]);

  const { ...DataReports } = useContext(ReportsDateProvider);
  const { data, error, loading } = useDashboardQuery(
    `Dashboard/Services/tasks/TeamCloseRank?top=7&todate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].toDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "toDate",
              Settings.Interval
            )
        : ""
    }&fromdate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].fromDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? defaultTimeFrame
          : handleIntervalCalculation(
              Settings.Interval.title,
              "fromDate",
              Settings.Interval
            )
        : defaultTimeFrame
    }${
      DataReports[0] === "Tasks"
        ? DataReports[5]
          ? `&workspace=true`
          : DataReports[4] === "Account"
          ? `&userid=${DataReports[2].Id}`
          : DataReports[4] === "Department"
          ? `&department=${DataReports[2].Id}`
          : DataReports[4] === "organization"
          ? `&company=${DataReports[2] && DataReports[2].Id}`
          : `&team=${DataReports[2].Id}`
        : ""
    }`
  );
  const user =
    DataReports[0] === "Tasks" ? (
      DataReports[2]?.Name
    ) : (
      <FormattedMessage id={"ME"} />
    );
  if (!loading && !error) {
    const { Results, HasData } = data;
    return (
      <div className="px-3 of-hidden h-100 d-flex flex-column">
        <div className="d-flex justify-content-between">
          <DashboardTitle
            className="mb-0 fs-20"
            text={<FormattedMessage id={"TEAM_TASK_AVERAGE"} />}
          />
          <div>{/* <FontAwesomeIcon icon={faEllipsisV} /> */}</div>
        </div>
        {DataReports[0] !== "Tasks" && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="mb-2">
              <span className="ar-dashboard-description">
                <FormattedMessage id={"INTERVAL"} />:
              </span>
              <span className="text-primary pl-1 fs-14">
                {Settings.Interval && Settings.Interval.title !== "ALL" ? (
                  <FormattedMessage id={Settings.Interval.title} />
                ) : (
                  <FormattedMessage id={"ALL"} />
                )}
              </span>
              <span className="ar-dashboard-description ml-1">
                | <FormattedMessage id={"SCOPE"} />:
              </span>
              <span className="text-primary pl-1 fs-14">{user}</span>
            </div>
            <Button
              className="ar-dashboard-card-settings-link"
              vType="link-primary"
              onClick={() =>
                openSidebar(
                  <DashboardCardSettingsForm
                    lS_Field={lS_Field}
                    lS_Group={lS_Group}
                    Settings={Settings}
                    closeSidebar={closeSidebar}
                    Title={"TEAM_TASK_AVERAGE"}
                    handleChanges={handleLayoutChange}
                    AvailableSettings={{
                      interval: true,
                      scope: true,
                      pipeline: false
                    }}
                  />
                )
              }
            >
              <FontAwesomeIcon icon={faCog} />
            </Button>
          </div>
        )}
        {HasData ? (
          <div className="h-100">
            <ClosedBarChart Data={Results} />
          </div>
        ) : (
          <DashboardEmptyResponse className="header h-100" type="tasks">
            <FormattedMessage id={"EMPTY_TASKS"} />
          </DashboardEmptyResponse>
        )}
        {/* {Results.length === 0 ? (
          <DashboardEmptyResponse className="header h-100" type="tasks">
            <FormattedMessage id={"EMPTY_TASKS"} />
          </DashboardEmptyResponse>
        ) : (
          <div className="h-100">
            <ClosedBarChart Data={Results} />
          </div>
        )} */}
      </div>
    );
  } else {
    if (!loading && error.status === 403) {
      return (
        <div className="px-3 of-hidden h-100 d-flex flex-column">
          <div className="d-flex justify-content-between">
            <DashboardTitle
              className="mb-0 fs-20"
              text={<FormattedMessage id={"TEAM_TASK_AVERAGE"} />}
            />
            <div>{/* <FontAwesomeIcon icon={faEllipsisV} /> */}</div>
          </div>
          {DataReports[0] !== "Tasks" && (
            <div className="d-flex justify-content-between align-items-center">
              <div className="mb-2">
                <span className="ar-dashboard-description">
                  <FormattedMessage id={"INTERVAL"} />:
                </span>
                <span className="text-primary pl-1 fs-14">
                  {Settings.Interval && Settings.Interval.title !== "ALL" ? (
                    <FormattedMessage id={Settings.Interval.title} />
                  ) : (
                    <FormattedMessage id={"ALL"} />
                  )}
                </span>
                <span className="ar-dashboard-description ml-1">
                  | <FormattedMessage id={"SCOPE"} />:
                </span>
                <span className="text-primary pl-1 fs-14">{user}</span>
              </div>
              <Button
                className="ar-dashboard-card-settings-link"
                vType="link-primary"
                onClick={() =>
                  openSidebar(
                    <DashboardCardSettingsForm
                      lS_Field={lS_Field}
                      lS_Group={lS_Group}
                      Settings={Settings}
                      closeSidebar={closeSidebar}
                      Title={"TEAM_TASK_AVERAGE"}
                      handleChanges={handleLayoutChange}
                      AvailableSettings={{
                        interval: true,
                        scope: true,
                        pipeline: false
                      }}
                    />
                  )
                }
              >
                <FontAwesomeIcon icon={faCog} />
              </Button>
            </div>
          )}

          <DashboardEmptyResponse type="tasks">
            {DataReports ? (
              DataReports[4] === "Account" ? (
                <FormattedMessage id={"EMPLOYEE_NO_DEPARTMNET"} />
              ) : (
                <FormattedMessage id={"EMPLOYE_NO_FILTER"} />
              )
            ) : (
              <FormattedMessage id={"EMPLOYEE"} />
            )}
          </DashboardEmptyResponse>
        </div>
      );
    }

    return (
      <BarLoader style={{ marginTop: -16 }} isLoading={loading || error} />
    );
  }
};

export const GlobalPerformanceTasks = () => {
  const [openSidebar, closeSidebar] = useSidebar();
  const lS_Field = "globalProductivityTasks";

  const DashboardSettings =
    JSON.parse(localStorage.getItem("ar-dashboard-settings")) || {};
  const Settings =
    (DashboardSettings &&
      DashboardSettings[lS_Group] &&
      DashboardSettings[lS_Group][lS_Field]) ||
    {};

  const handleLayoutChange = useContext(DashboardSettingsContext);

  useEffect(() => {
    return () => closeSidebar();
  }, [closeSidebar]);

  const { ...DataReports } = useContext(ReportsDateProvider);
  const { data, error, loading } = useDashboardQuery(
    `Dashboard/Services/Tasks/Performance?todate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].toDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "toDate",
              Settings.Interval
            )
        : ""
    }&fromdate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].fromDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? defaultTimeFrame
          : handleIntervalCalculation(
              Settings.Interval.title,
              "fromDate",
              Settings.Interval
            )
        : defaultTimeFrame
    }${
      DataReports[0] === "Tasks"
        ? DataReports[5]
          ? `&workspace=true`
          : DataReports[4] === "Account"
          ? `&userid=${DataReports[2].Id}`
          : DataReports[4] === "Department"
          ? `&department=${DataReports[2].Id}`
          : DataReports[4] === "organization"
          ? `&company=${DataReports[2] && DataReports[2].Id}`
          : `&team=${DataReports[2].Id}`
        : ""
    }`
  );
  const user =
    DataReports[0] === "Tasks" ? (
      DataReports[2]?.Name
    ) : (
      <FormattedMessage id={"ME"} />
    );
  const resolvedData = useMemo(() => {
    let count = 0;
    if (!data) return null;

    const resolvedData = {};
    const { Results } = data;
    if (Array.isArray(Results)) {
      for (const e of Results) {
        if (e.Status === 1) {
          resolvedData.Open = [e.Count, Math.round(e.Percentage)];
          count += e.Count;
        } else if (e.Status === 3) {
          resolvedData.Canceled = [e.Count, Math.round(e.Percentage)];
          count += e.Count;
        } else if (e.Status === 4) {
          resolvedData.Closed = [e.Count, Math.round(e.Percentage)];
          count += e.Count;
        }
      }
    }
    return [resolvedData, count];
  }, [data]);

  if (!loading && !error) {
    return (
      <div className="px-3 of-hidden h-100 d-flex flex-column">
        <div className="d-flex justify-content-between">
          <DashboardTitle
            className="mb-0 fs-20"
            text={<FormattedMessage id={"OVERALL_TASK_PERFORMANCE"} />}
          />
          <div>{/* <FontAwesomeIcon icon={faEllipsisV} /> */}</div>
        </div>
        {DataReports[0] !== "Tasks" && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="mb-2">
              <span className="ar-dashboard-description">
                <FormattedMessage id={"INTERVAL"} />:
              </span>
              <span className="text-primary pl-1 fs-14">
                {Settings.Interval && Settings.Interval.title !== "ALL" ? (
                  <FormattedMessage id={Settings.Interval.title} />
                ) : (
                  <FormattedMessage id={"ALL"} />
                )}
              </span>
              <span className="ar-dashboard-description ml-1">
                | <FormattedMessage id={"SCOPE"} />:
              </span>
              <span className="text-primary pl-1 fs-14">{user}</span>
            </div>
            <Button
              className="ar-dashboard-card-settings-link"
              vType="link-primary"
              onClick={() =>
                openSidebar(
                  <DashboardCardSettingsForm
                    lS_Field={lS_Field}
                    lS_Group={lS_Group}
                    Settings={Settings}
                    closeSidebar={closeSidebar}
                    Title={"OVERALL_TASK_PERFORMANCE"}
                    handleChanges={handleLayoutChange}
                    AvailableSettings={{
                      interval: true,
                      scope: true,
                      pipeline: false
                    }}
                  />
                )
              }
            >
              <FontAwesomeIcon icon={faCog} />
            </Button>
          </div>
        )}
        {data.HasData ? (
          <div className="h-100">
            <div className="fs-40 text-black pt-3">
              {resolvedData[1]} <FormattedMessage id={"TASKS"} />
            </div>
            <BigBarChartPerformance Data={resolvedData[0]} />
          </div>
        ) : (
          <DashboardEmptyResponse className="header h-100" type="tasks">
            <FormattedMessage id={"EMPTY_TASKS"} />
          </DashboardEmptyResponse>
        )}
      </div>
    );
  } else {
    return (
      <BarLoader style={{ marginTop: -16 }} isLoading={loading || error} />
    );
  }
};

export const PipelineWorkloadTask = () => {
  const { data, error, loading } = useDashboardQuery(`query/Pipelines?Type=4`, [
    spacePipelineSchema
  ]);

  if (!loading && !error) {
    return <TaskstatusTimesTotals results={data} />;
  } else {
    return <BarLoader style={{ marginTop: -16 }} isLoading={loading} />;
  }
};

const TaskstatusTimesTotals = ({ results }) => {
  const [openSidebar, closeSidebar] = useSidebar();
  const lS_Field = "PipelineWorkloadTask";

  const DashboardSettings =
    JSON.parse(localStorage.getItem("ar-dashboard-settings")) || {};
  const Settings = (DashboardSettings &&
    DashboardSettings[lS_Group] &&
    DashboardSettings[lS_Group][lS_Field]) || { Pipeline: results[0] };
  const handleLayoutChange = useContext(DashboardSettingsContext);

  useEffect(() => {
    return () => closeSidebar();
  }, [closeSidebar]);

  const { ...DataReports } = useContext(ReportsDateProvider);
  const pipeline =
    DataReports[0] === "Tasks" ? DataReports[3] : Settings.Pipeline;
  const { data, error, loading } = useDashboardQuery(
    `Dashboard/Services/Tasks/AverageStatus?pipelineId=${
      pipeline ? pipeline : Settings.Pipeline
    }&todate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].toDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "toDate",
              Settings.Interval
            )
        : ""
    }&fromdate=${
      DataReports[0] === "Tasks"
        ? DataReports[1].fromDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "fromDate",
              Settings.Interval
            )
        : ""
    }${
      DataReports[0] === "Tasks"
        ? DataReports[5]
          ? `&workspace=true`
          : DataReports[4] === "Account"
          ? `&userid=${DataReports[2].Id}`
          : DataReports[4] === "Department"
          ? `&department=${DataReports[2].Id}`
          : DataReports[4] === "organization"
          ? `&company=${DataReports[2] && DataReports[2].Id}`
          : `&team=${DataReports[2].Id}`
        : ""
    }`
  );
  const user =
    DataReports[0] === "Tasks" ? (
      DataReports[2]?.Name
    ) : (
      <FormattedMessage id={"ME"} />
    );

  if (!loading && !error) {
    // data.splice(20, data.length - 21);
    const { Results, HasData } = data;
    const resolvedData = HasData ? Results.filter((e) => e.PipelineStatus.Status !== 5) : [];
    const user =
      DataReports[0] === "Projects" ? (
        DataReports[2]?.Name
      ) : (
        <FormattedMessage id={"ME"} />
      );
    return (
      <div className="px-3 of-hidden h-100 d-flex flex-column">
        <div className="d-flex justify-content-between">
          <DashboardTitle
            className="mb-0 fs-20"
            text={<FormattedMessage id={"AVERAGE_STATUS"} />}
          />
          <div>{/* <FontAwesomeIcon icon={faEllipsisV} /> */}</div>
        </div>
        {DataReports[0] !== "Tasks" && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="mb-2">
              <span className="ar-dashboard-description">
                <FormattedMessage id={"INTERVAL"} />:
              </span>
              <span className="text-primary pl-1 fs-14">
                {Settings.Interval && Settings.Interval.title !== "ALL" ? (
                  <FormattedMessage id={Settings.Interval.title} />
                ) : (
                  <FormattedMessage id={"ALL"} />
                )}
              </span>
              <span className="ar-dashboard-description ml-1">
                | <FormattedMessage id={"SCOPE"} />:
              </span>
              <span className="text-primary pl-1 fs-14">{user}</span>
              <span className="ar-dashboard-description ml-1">
                | <FormattedMessage id={"PIPELINE"} />:
              </span>
              <span className="text-primary pl-1 fs-14">
                {
                  getEntity(
                    spacePipelineSchema,
                    pipeline ? pipeline : Settings.Pipeline
                  )?.Name
                }
              </span>
            </div>
            <Button
              className="ar-dashboard-card-settings-link"
              vType="link-primary"
              onClick={() =>
                openSidebar(
                  <DashboardCardSettingsForm
                    lS_Field={lS_Field}
                    lS_Group={lS_Group}
                    Settings={Settings}
                    closeSidebar={closeSidebar}
                    pipelineType={4}
                    Title={"AVERAGE_STATUS"}
                    handleChanges={handleLayoutChange}
                    AvailableSettings={{
                      interval: true,
                      scope: true,
                      pipeline: true
                    }}
                  />
                )
              }
            >
              <FontAwesomeIcon icon={faCog} />
            </Button>
          </div>
        )}
        {HasData ? (
          <div className="h-100">
            <PipelineWorkloadComboLoadChart Data={resolvedData} />
          </div>
        ) : (
          <DashboardEmptyResponse className="header h-100" type="tasks">
            <FormattedMessage id={"EMPTY_TASKS"} />
          </DashboardEmptyResponse>
        )}
      </div>
    );
  } else {
    if (!loading && error.status === 403) {
      return (
        <div className="px-3 of-hidden h-100 d-flex flex-column">
          <div className="d-flex justify-content-between">
            <DashboardTitle
              className="mb-0 fs-20"
              text={<FormattedMessage id={"AVERAGE_STATUS"} />}
            />
            <div>{/* <FontAwesomeIcon icon={faEllipsisV} /> */}</div>
          </div>
          {DataReports[0] !== "Tasks" && (
            <div className="d-flex justify-content-between align-items-center">
              <div className="mb-2">
                <span className="ar-dashboard-description">
                  <FormattedMessage id={"INTERVAL"} />:
                </span>
                <span className="text-primary pl-1 fs-14">
                  {Settings.Interval && Settings.Interval.title !== "ALL" ? (
                    <FormattedMessage id={Settings.Interval.title} />
                  ) : (
                    <FormattedMessage id={"ALL"} />
                  )}
                </span>
                <span className="ar-dashboard-description ml-1">
                  | <FormattedMessage id={"SCOPE"} />:
                </span>
                <span className="text-primary pl-1 fs-14">{user}</span>
                <span className="ar-dashboard-description ml-1">
                  | <FormattedMessage id={"PIPELINE"} />:
                </span>
                <span className="text-primary pl-1 fs-14">
                  {
                    getEntity(
                      spacePipelineSchema,
                      pipeline ? pipeline : Settings.Pipeline
                    )?.Name
                  }
                </span>
              </div>
              <Button
                className="ar-dashboard-card-settings-link"
                vType="link-primary"
                onClick={() =>
                  openSidebar(
                    <DashboardCardSettingsForm
                      lS_Field={lS_Field}
                      lS_Group={lS_Group}
                      Settings={Settings}
                      closeSidebar={closeSidebar}
                      pipelineType={4}
                      Title={"AVERAGE_STATUS"}
                      handleChanges={handleLayoutChange}
                      AvailableSettings={{
                        interval: true,
                        scope: true,
                        pipeline: true
                      }}
                    />
                  )
                }
              >
                <FontAwesomeIcon icon={faCog} />
              </Button>
            </div>
          )}

          <DashboardEmptyResponse type="tasks">
            {DataReports ? (
              DataReports[4] === "Account" ? (
                <FormattedMessage id={"EMPLOYEE_NO_DEPARTMNET"} />
              ) : (
                <FormattedMessage id={"EMPLOYE_NO_FILTER"} />
              )
            ) : (
              <FormattedMessage id={"EMPLOYEE"} />
            )}
          </DashboardEmptyResponse>
        </div>
      );
    }

    return (
      <BarLoader style={{ marginTop: -16 }} isLoading={loading || error} />
    );
  }
};
